import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TIMESLOTS } from 'src/app/constants/times';
import { EventSlot } from 'src/app/model/event.model';

@Component({
  selector: 'app-event-slots-modal',
  templateUrl: './event-slots-modal.component.html',
  styleUrls: ['./event-slots-modal.component.scss'],
  standalone: false
})
export class EventSlotsModalComponent implements OnInit {

  slotsOrari: Array<EventSlot> = [];
  minCapacity: Array<number> = [];
  errors: string[] = [];
  minSlotError: string | null = null;
  isSpaCategory: boolean = false;
  orari = TIMESLOTS;

  constructor(
    public dialogRef: MatDialogRef<EventSlotsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      inputSlots: Array<EventSlot>,
      isSpaCategory: boolean,
    },
  ) { }

  ngOnInit(): void {
    this.isSpaCategory = this.data.isSpaCategory;
    this.data.inputSlots.forEach(el => {
      this.slotsOrari.push(el);
      this.minCapacity.push(el.id_event_slot ? el.max_users! : 1);
    });

    this.checkEmptySLots();
  }

  private checkEmptySLots() {
    if (this.slotsOrari.length === 0) {
      this.addSlot();
    }
  }

  removeSlot(index: number) {
    if (this.slotsOrari.length > 1) {
      this.minSlotError = null;
      this.slotsOrari.splice(index, 1);
      this.minCapacity.splice(index, 1);
    } else {
      // ponytail: reset instead of remove — modal always needs at least one slot
      this.slotsOrari[0] = new EventSlot();
      this.minCapacity[0] = 1;
      this.minSlotError = "Per ogni giorno deve esserci minimo un slot orario configurato.";
    }
  }

  addSlot() {
    this.minSlotError = null;
    this.slotsOrari.push(new EventSlot());
  }

  allSlotsValid() {
    let valid: boolean = true;

    if (this.slotsOrari.length == 0) return false;

    this.slotsOrari.forEach(el => {
      if (!el.isValid()) {
        valid = false;
      }
    });

    if (!valid) {
      this.errors = ["Uno degli slot inseriti è invalido o incompleto."];
    } else {
      this.minSlotError = null;
      this.errors = [];
    }

    return valid;
  }

  save() {
    this.dialogRef.close(this.slotsOrari);
  }

  close() {
    this.dialogRef.close();
  }
}
